export default "__VITE_ASSET__DJ2OcjYn__"